import { ItemBidsDialogController } from "./item-bids-dialog.controller";

export class ItemBidsTriggerController {
    public static $inject: string[] = [
        "$mdDialog",
        "$mdMedia"
    ];

    // binded
    public itemId: number;

    constructor(
        private $mdDialog: ng.material.IDialogService,
        private $mdMedia: ng.material.IMedia
    ) {}

    public showItemBidsDialog(itemId: number = this.itemId) {
        this.$mdDialog.show({
            controller: ItemBidsDialogController,
            controllerAs: "itemBidsDialogCtrl",
            template: require("./item-bids-dialog.html"),
            locals: {
                itemId
            },
            bindToController: true,
            fullscreen: this.$mdMedia("xs")
        });
    }
}
